import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { service_controllers_methods } from './service_controllers_methods';
import { ActiveInactiveFor, GeneralConfigType, Header, KeyValues3, LocalService, Paging, StatusWithId, Wrapper10, Wrappers3WithStatus, Wrappers10, MenuWrapper, PageKey, Status, Wrappers5, Wrappers5WithStatus, KeyValues5 } from './local.service';
import { HttpRequestComponent } from '../app/shared/http-request/http-request.component';

@Injectable({
  providedIn: 'root'
})
export class MenuManagementService {
  private controllerName = service_controllers_methods.menu.controller;
  private methods = service_controllers_methods.menu.methods;

  constructor(private localService: LocalService, private httpService: HttpRequestComponent) { }

  public saveMenu(wrapper: Wrapper10): Observable<StatusWithId> {
    let body = {
      wrapper: wrapper,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveMenu, body);
  }

  public getMenus(paging: Paging): Observable<Wrappers10> {
    if (paging == null)
      paging = this.localService.getLastPagingSetup(GeneralConfigType.PagingMenus);

    let body = {
      sel: this.localService.getSelected(),
      pag: paging,
      isOnlyActive: false
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMenus, body, paging != null && !paging.isAutoRefresh);
  }

  public getMenu(id: string): Observable<Wrapper10> {
    let body = {
      strId: id,
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMenu, body);
  }

  public activeInactiveStatus(strId: string, actionFor: ActiveInactiveFor): any {
    let body = {
      strId: strId,
      sel: this.localService.getSelected(),
      iActionFor: parseInt(actionFor.toString())
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.ActiveInactiveStatus, body);
  }

  public getNextOrder(strParentId: string): any {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strParentId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNextOrder, body);
  }

  public getHeader(): Observable<Header> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetHeader, body);
  }

  public getPublicMenus(strUserId: string = '', isShowSpinner = true): Observable<MenuWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: strUserId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetPublicMenus, body, isShowSpinner);
  }

  public getNotifications(strBusinessId: string, isInitial: boolean, isIncRead: boolean, paging: Paging, isSpinnerNeed = false): Observable<Wrappers5WithStatus> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: isInitial ? '1' : '0', v2: isIncRead ? '1' : '0', v3: strBusinessId, v4: this.localService.loggedMember.loggedMember.content.v10 } as KeyValues5,
      pag: paging,
      devices: this.localService.getLastDeviceSettings(this.localService.loggedMember.loggedMember.content.v9)
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetNotifications, body, isSpinnerNeed);
  }

  public markAsRead(strId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      strId: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.MarkAsRead, body);
  }

  public getMenusUsedByPageKeys(pageKey: PageKey): Observable<MenuWrapper> {
    let body = {
      sel: this.localService.getSelected(),
      dt: { v1: pageKey.toString() } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetMenusUsedByPageKeys, body);
  }

  public saveCustomizeMenu(lstPageKeys: number[], strUserId: string = ''): Observable<Status> {
    let body = {
      sel: this.localService.getSelected(),
      dt: lstPageKeys,
      dtC: { v1: strUserId } as KeyValues3
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.SaveCustomizeMenu, body);
  }

  public getActivePageKeys(): Observable<number[]> {
    let body = {
      sel: this.localService.getSelected()
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetActivePageKeys, body);
  }

  public getShortenUrl(strId: string): Observable<StatusWithId> {
    let body = {
      sel: this.localService.getSelected(),
      strId: strId
    };
    return this.httpService.request_general_post(this.controllerName + this.methods.GetShortenUrl, body);
  }
}
